module.exports = __webpack_public_path__ + "static/assets/3ef0ce285e2eeaf320c2a23e8bec0183.png";